module.exports = __webpack_public_path__ + "img/full4-min.cc6bb6d5.png";